import {createApp} from "vue";
import i18n from "../../plugins/i18n";
import {Countdown} from "@webstacz/shop-components";

for (const el of document.querySelectorAll('.campaign-countdown')) {
    const dateTo = el.getAttribute('data-date');
    const texts = JSON.parse(window.atob(el.getAttribute('data-texts')));
    const backgroundColor = el.getAttribute('data-background-color');
    const textColor = el.getAttribute('data-text-color');
    const isResponsive = el.hasAttribute('data-is-responsive');

    createApp(Countdown, {
        dateTo,
        texts,
        backgroundColor,
        textColor,
        isResponsive,
    })
        .use(i18n)
        .mount(el);
}
